

/**
 * Converts a string to title case — capitalizes the first letter
 * and lowercases the rest, regardless of input casing.
 * e.g. "eRling" -> "Erling", "ERLING" -> "Erling"
 *
 * Returns an empty string for null/undefined/blank input.
 */
export function toTitleCase(value: string | null | undefined): string {
  if (!value) return '';
  const trimmed = value.trim();
  if (!trimmed) return '';
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
}

/**
 * Same as toTitleCase, but applies per word — useful for full names.
 * e.g. "john SMITH" -> "John Smith"
 */
export function toTitleCasePerWord(value: string | null | undefined): string {
  if (!value) return '';
  return value
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function toUpperCase(value: string | null | undefined): string {
  if (!value) return '';
  const trimmed = value.trim();
  if (!trimmed) return '';
  return trimmed.toUpperCase();
}